// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { useEffect } from "react";

/**
 * usePostMessageListener
 * Custom hook to listen for `postMessage` events in the parent window.
 *
 * @param {Function} onMessage - Function to run when a valid message is received.
 * @param {string} [expectedOrigin="*"] - (Optional) Expected origin to filter messages from.
 */
const usePostMessageListener = (onMessage) => {
  const expectedOrigin = "*"
  useEffect(() => {
    const handleMessage = async (event) => {
      if (expectedOrigin !== "*" && event.origin !== expectedOrigin) return;

      await onMessage(event.data?.type, event.data.payload, event);
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [onMessage, expectedOrigin]);
};

export default usePostMessageListener;
